(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .controller('ProtocolCategoryOverviewController', ProtocolCategoryOverviewControllerFn);

    /* controller for protocol categories */
    ProtocolCategoryOverviewControllerFn.$inject = ['$scope', 'ItemTableService', 'protocolCategories'];

    function ProtocolCategoryOverviewControllerFn($scope, ItemTableService, protocolCategories) {
        var vm = this;

        // table service data
        vm.overview = null;

        // metronic init 
        $scope.$on('$viewContentLoaded', function () {
            App.initAjax(); // initialize core components
        });

        // start
        activate();

        // sort by date
        function orderBy(a, b) {
            return a.sortOrder - b.sortOrder; // ascending
        } // orderBy
        
        /* activation work */
        function activate() {
            // service
            vm.overview = ItemTableService;
            // put sort function to table
            vm.overview.data.sortFn = orderBy;


            // init table-item list
            vm.overview.init(protocolCategories.data);
            vm.overview.sort();


        } // activate
    }
})();
